var map = {
	"./activities/elections/election_post/da.yml": 405,
	"./activities/elections/election_post/en.yml": 406,
	"./activities/index/card/da.yml": 407,
	"./activities/index/card/description/da.yml": 408,
	"./activities/index/card/description/en.yml": 409,
	"./activities/index/card/en.yml": 410,
	"./activities/index/da.yml": 411,
	"./activities/index/en.yml": 412,
	"./activities/link_cards/index/da.yml": 413,
	"./activities/link_cards/index/en.yml": 414,
	"./activities/register_button/da.yml": 415,
	"./activities/register_button/en.yml": 416,
	"./activities/regret_unregister_button/da.yml": 417,
	"./activities/regret_unregister_button/en.yml": 418,
	"./activities/show/da.yml": 419,
	"./activities/show/en.yml": 420,
	"./activities/show/politics/da.yml": 421,
	"./activities/show/politics/en.yml": 422,
	"./admin/abilities/table/da.yml": 423,
	"./admin/abilities/table/en.yml": 424,
	"./admin/ability_group_abilities/lock_icon/da.yml": 425,
	"./admin/ability_group_abilities/lock_icon/en.yml": 426,
	"./admin/ability_groups/edit/da.yml": 427,
	"./admin/ability_groups/edit/en.yml": 428,
	"./admin/ability_groups/table/da.yml": 429,
	"./admin/ability_groups/table/en.yml": 430,
	"./admin/activities/activities_nav/da.yml": 431,
	"./admin/activities/activities_nav/en.yml": 432,
	"./admin/activities/billing/da.yml": 433,
	"./admin/activities/billing/en.yml": 434,
	"./admin/activities/children/da.yml": 435,
	"./admin/activities/children/en.yml": 436,
	"./admin/activities/create_card/expandable_content/da.yml": 437,
	"./admin/activities/create_card/expandable_content/en.yml": 438,
	"./admin/activities/create_card/surveys_card/da.yml": 439,
	"./admin/activities/create_card/surveys_card/en.yml": 440,
	"./admin/activities/edit/da.yml": 441,
	"./admin/activities/edit/en.yml": 442,
	"./admin/activities/index/da.yml": 443,
	"./admin/activities/index/en.yml": 444,
	"./admin/activities/live/agenda/item_types/election/election_post/da.yml": 445,
	"./admin/activities/live/agenda/item_types/election/election_post/en.yml": 446,
	"./admin/activities/live/agenda/item_types/election/election_post_card/da.yml": 447,
	"./admin/activities/live/agenda/item_types/election/election_post_card/en.yml": 448,
	"./admin/activities/live/agenda/item_types/election/election_post_contact_card/da.yml": 449,
	"./admin/activities/live/agenda/item_types/election/election_post_contact_card/en.yml": 450,
	"./admin/activities/live/agenda/item_types/election/index/da.yml": 451,
	"./admin/activities/live/agenda/item_types/election/index/en.yml": 452,
	"./admin/activities/live/agenda/item_types/proposal/proposal_card/da.yml": 453,
	"./admin/activities/live/agenda/item_types/proposal/proposal_card/en.yml": 454,
	"./admin/activities/live/agenda/item_types/speaker_list/actions_bar/next_speaker_button/da.yml": 455,
	"./admin/activities/live/agenda/item_types/speaker_list/actions_bar/next_speaker_button/en.yml": 456,
	"./admin/activities/live/agenda/item_types/speaker_list/da.yml": 457,
	"./admin/activities/live/agenda/item_types/speaker_list/en.yml": 458,
	"./admin/activities/live_nav/da.yml": 459,
	"./admin/activities/live_nav/en.yml": 460,
	"./admin/activities/nav/da.yml": 461,
	"./admin/activities/nav/en.yml": 462,
	"./admin/activities/participants/da.yml": 463,
	"./admin/activities/participants/en.yml": 464,
	"./admin/activities/participants/index/da.yml": 465,
	"./admin/activities/participants/index/en.yml": 466,
	"./admin/activities/politics/proposals/da.yml": 467,
	"./admin/activities/politics/proposals/en.yml": 468,
	"./admin/activities/surveys/da.yml": 469,
	"./admin/activities/surveys/en.yml": 470,
	"./admin/activities/table/da.yml": 471,
	"./admin/activities/table/en.yml": 472,
	"./admin/activity_groups/create_card/da.yml": 473,
	"./admin/activity_groups/create_card/en.yml": 474,
	"./admin/activity_participant_type_rules/create_card/da.yml": 475,
	"./admin/activity_participant_type_rules/create_card/en.yml": 476,
	"./admin/activity_participant_type_rules/table/da.yml": 477,
	"./admin/activity_participant_type_rules/table/en.yml": 478,
	"./admin/activity_participants/expandable_content/da.yml": 479,
	"./admin/activity_participants/expandable_content/en.yml": 480,
	"./admin/activity_participants/index/da.yml": 481,
	"./admin/activity_participants/index/en.yml": 482,
	"./admin/activity_participants/invite/da.yml": 483,
	"./admin/activity_participants/invite/en.yml": 484,
	"./admin/activity_participants/requested_unregister/da.yml": 485,
	"./admin/activity_participants/requested_unregister/en.yml": 486,
	"./admin/activity_participants/table/da.yml": 487,
	"./admin/activity_participants/table/en.yml": 488,
	"./admin/activity_surveys/edit/da.yml": 489,
	"./admin/activity_surveys/edit/en.yml": 490,
	"./admin/activity_surveys/table/da.yml": 491,
	"./admin/activity_surveys/table/en.yml": 492,
	"./admin/agenda_item_element_speakers/create_card/da.yml": 493,
	"./admin/agenda_item_element_speakers/create_card/en.yml": 494,
	"./admin/agenda_item_element_speakers/table/da.yml": 495,
	"./admin/agenda_item_element_speakers/table/en.yml": 496,
	"./admin/agenda_item_elements/create_card/da.yml": 497,
	"./admin/agenda_item_elements/create_card/en.yml": 498,
	"./admin/agenda_items/create_card/da.yml": 499,
	"./admin/agenda_items/create_card/en.yml": 500,
	"./admin/agendas/create_card/da.yml": 501,
	"./admin/agendas/create_card/en.yml": 502,
	"./admin/agendas/live_button/da.yml": 503,
	"./admin/agendas/live_button/en.yml": 504,
	"./admin/bank_accounts/bank_account_modal/da.yml": 505,
	"./admin/bank_accounts/da.yml": 506,
	"./admin/bank_accounts/en.yml": 507,
	"./admin/bank_accounts/table/da.yml": 508,
	"./admin/bank_accounts/table/en.yml": 509,
	"./admin/bundle_photo_product/create_card/da.yml": 510,
	"./admin/bundle_photo_product/create_card/en.yml": 511,
	"./admin/bundles/edit/da.yml": 512,
	"./admin/bundles/edit/en.yml": 513,
	"./admin/bundles/select/da.yml": 514,
	"./admin/bundles/select/en.yml": 515,
	"./admin/bundles/show/da.yml": 516,
	"./admin/bundles/show/en.yml": 517,
	"./admin/call_list_entities/table/da.yml": 518,
	"./admin/call_list_entities/table/en.yml": 519,
	"./admin/call_lists/call_mode/call_list_entity_carousel/da.yml": 520,
	"./admin/call_lists/call_mode/call_list_entity_carousel/en.yml": 521,
	"./admin/call_lists/call_mode/index/da.yml": 522,
	"./admin/call_lists/call_mode/index/en.yml": 523,
	"./admin/call_lists/edit/da.yml": 524,
	"./admin/call_lists/edit/en.yml": 525,
	"./admin/call_lists/index/da.yml": 526,
	"./admin/call_lists/index/en.yml": 527,
	"./admin/call_lists/show/call_list_carousel/index/da.yml": 528,
	"./admin/call_lists/show/call_list_carousel/index/en.yml": 529,
	"./admin/call_lists/show/table/da.yml": 530,
	"./admin/call_lists/show/table/en.yml": 531,
	"./admin/call_lists/table/da.yml": 532,
	"./admin/call_lists/table/en.yml": 533,
	"./admin/comments/da.yml": 534,
	"./admin/comments/en.yml": 535,
	"./admin/comments/expanded_content_partial/da.yml": 536,
	"./admin/comments/expanded_content_partial/en.yml": 537,
	"./admin/comments/index/da.yml": 538,
	"./admin/comments/index/en.yml": 539,
	"./admin/communication/bottom_bar/da.yml": 540,
	"./admin/communication/bottom_bar/en.yml": 541,
	"./admin/communication/index/da.yml": 542,
	"./admin/communication/index/en.yml": 543,
	"./admin/communication/templates/da.yml": 544,
	"./admin/communication/templates/en.yml": 545,
	"./admin/competition_surveys/edit/da.yml": 546,
	"./admin/competition_surveys/edit/en.yml": 547,
	"./admin/competition_surveys/surveys/da.yml": 548,
	"./admin/competition_surveys/surveys/en.yml": 549,
	"./admin/competitions/edit/da.yml": 550,
	"./admin/competitions/edit/en.yml": 551,
	"./admin/competitions/form/da.yml": 552,
	"./admin/competitions/form/en.yml": 553,
	"./admin/competitions/index/da.yml": 554,
	"./admin/competitions/index/en.yml": 555,
	"./admin/competitions/surveys/da.yml": 556,
	"./admin/competitions/surveys/en.yml": 557,
	"./admin/components/photo_session_csvs/table/da.yml": 558,
	"./admin/components/photo_session_csvs/table/en.yml": 559,
	"./admin/components/photos/index/bottom_bar/da.yml": 560,
	"./admin/components/photos/index/bottom_bar/en.yml": 561,
	"./admin/components/sheet_layout_boxes/form/da.yml": 562,
	"./admin/components/sheet_layout_boxes/form/en.yml": 563,
	"./admin/contact_associates/create_card/da.yml": 564,
	"./admin/contact_associates/create_card/en.yml": 565,
	"./admin/contact_group_contacts/create_modal/da.yml": 566,
	"./admin/contact_group_contacts/create_modal/en.yml": 567,
	"./admin/contact_relationships/edit/da.yml": 568,
	"./admin/contact_relationships/edit/en.yml": 569,
	"./admin/contacts/anonymize_button/da.yml": 570,
	"./admin/contacts/anonymize_button/en.yml": 571,
	"./admin/contacts/convert_organization_to_person_button/da.yml": 572,
	"./admin/contacts/convert_organization_to_person_button/en.yml": 573,
	"./admin/contacts/edit/billing_contact/da.yml": 574,
	"./admin/contacts/edit/billing_contact/en.yml": 575,
	"./admin/contacts/edit/da.yml": 576,
	"./admin/contacts/edit/email/da.yml": 577,
	"./admin/contacts/edit/email/en.yml": 578,
	"./admin/contacts/edit/en.yml": 579,
	"./admin/contacts/edit/historical_data_card/da.yml": 580,
	"./admin/contacts/edit/historical_data_card/en.yml": 581,
	"./admin/contacts/edit/organization_content/da.yml": 582,
	"./admin/contacts/edit/organization_content/en.yml": 583,
	"./admin/contacts/edit/relationships/da.yml": 584,
	"./admin/contacts/edit/relationships/en.yml": 585,
	"./admin/contacts/edit/school_content/da.yml": 586,
	"./admin/contacts/edit/school_content/en.yml": 587,
	"./admin/contacts/edit/student_council_content/da.yml": 588,
	"./admin/contacts/edit/student_council_content/en.yml": 589,
	"./admin/contacts/edit/supplier_content/da.yml": 590,
	"./admin/contacts/edit/supplier_content/en.yml": 591,
	"./admin/contacts/index/bottom_bar/add_to_activity/da.yml": 592,
	"./admin/contacts/index/bottom_bar/add_to_activity/en.yml": 593,
	"./admin/contacts/index/bottom_bar/da.yml": 594,
	"./admin/contacts/index/bottom_bar/en.yml": 595,
	"./admin/contacts/index/da.yml": 596,
	"./admin/contacts/index/en.yml": 597,
	"./admin/contacts/index/expandable_content/da.yml": 598,
	"./admin/contacts/index/expandable_content/en.yml": 599,
	"./admin/contacts/index/filter_content/da.yml": 600,
	"./admin/contacts/index/filter_content/en.yml": 601,
	"./admin/contacts/index/old_nemoa_filter/da.yml": 602,
	"./admin/contacts/index/old_nemoa_filter/en.yml": 603,
	"./admin/contacts/link/da.yml": 604,
	"./admin/contacts/link/en.yml": 605,
	"./admin/contacts/merge/da.yml": 606,
	"./admin/contacts/merge/en.yml": 607,
	"./admin/contacts/relations/da.yml": 608,
	"./admin/contacts/relations/en.yml": 609,
	"./admin/contacts/show/create_user_modal/da.yml": 610,
	"./admin/contacts/show/create_user_modal/en.yml": 611,
	"./admin/contacts/show/da.yml": 612,
	"./admin/contacts/show/economy_and_integrations/da.yml": 613,
	"./admin/contacts/show/economy_and_integrations/en.yml": 614,
	"./admin/contacts/show/en.yml": 615,
	"./admin/contacts/show/historical_data_card/da.yml": 616,
	"./admin/contacts/show/historical_data_card/en.yml": 617,
	"./admin/contacts/show/memberships/add_subscription_card/da.yml": 618,
	"./admin/contacts/show/memberships/add_subscription_card/en.yml": 619,
	"./admin/contacts/show/nav/da.yml": 620,
	"./admin/contacts/show/nav/en.yml": 621,
	"./admin/contacts/show/organization_further_information_card/da.yml": 622,
	"./admin/contacts/show/organization_further_information_card/en.yml": 623,
	"./admin/contacts/show/organization_general_information_card/da.yml": 624,
	"./admin/contacts/show/organization_general_information_card/en.yml": 625,
	"./admin/contacts/show/person/surveys_nav/da.yml": 626,
	"./admin/contacts/show/person/surveys_nav/en.yml": 627,
	"./admin/contacts/show/person/user_teams/da.yml": 628,
	"./admin/contacts/show/person/user_teams/en.yml": 629,
	"./admin/contacts/show/person_general_information_card/da.yml": 630,
	"./admin/contacts/show/person_general_information_card/en.yml": 631,
	"./admin/contacts/show/realtions/da.yml": 632,
	"./admin/contacts/show/realtions/en.yml": 633,
	"./admin/contacts/show/relations/da.yml": 634,
	"./admin/contacts/show/relations/en.yml": 635,
	"./admin/contacts/show/school_information_card/da.yml": 636,
	"./admin/contacts/show/school_information_card/en.yml": 637,
	"./admin/contacts/show/student_council_information_card/da.yml": 638,
	"./admin/contacts/show/student_council_information_card/en.yml": 639,
	"./admin/contacts/show/uni_c/da.yml": 640,
	"./admin/contacts/show/uni_c/en.yml": 641,
	"./admin/contacts/show/user/da.yml": 642,
	"./admin/contacts/show/user/en.yml": 643,
	"./admin/contacts/status_select/da.yml": 644,
	"./admin/contacts/status_select/en.yml": 645,
	"./admin/contacts/update_number_of_students_from_csv/da.yml": 646,
	"./admin/contacts/update_number_of_students_from_csv/en.yml": 647,
	"./admin/economy/account_dimensions/da.yml": 648,
	"./admin/economy/account_dimensions/en.yml": 649,
	"./admin/economy/accounts/da.yml": 650,
	"./admin/economy/accounts/en.yml": 651,
	"./admin/economy/accounts/index/da.yml": 652,
	"./admin/economy/accounts/index/en.yml": 653,
	"./admin/economy/dimensions/da.yml": 654,
	"./admin/economy/dimensions/en.yml": 655,
	"./admin/economy/dimensions/index/da.yml": 656,
	"./admin/economy/dimensions/index/en.yml": 657,
	"./admin/economy/dimensions/locked_dimensions/da.yml": 658,
	"./admin/economy/employees/da.yml": 659,
	"./admin/economy/employees/en.yml": 660,
	"./admin/economy/index/da.yml": 661,
	"./admin/economy/index/en.yml": 662,
	"./admin/economy/invoices/da.yml": 663,
	"./admin/economy/invoices/en.yml": 664,
	"./admin/economy/nav/da.yml": 665,
	"./admin/economy/nav/en.yml": 666,
	"./admin/economy/subscription_renewal_generations/choose_plan_modal/da.yml": 667,
	"./admin/economy/subscription_renewal_generations/choose_plan_modal/en.yml": 668,
	"./admin/economy/subscription_renewal_generations/da.yml": 669,
	"./admin/economy/subscription_renewal_generations/en.yml": 670,
	"./admin/election_posts/table/da.yml": 671,
	"./admin/election_posts/table/en.yml": 672,
	"./admin/element_feedback/da.yml": 673,
	"./admin/element_feedback/en.yml": 674,
	"./admin/elements/edit/da.yml": 675,
	"./admin/elements/edit/en.yml": 676,
	"./admin/elements/show/da.yml": 677,
	"./admin/elements/show/en.yml": 678,
	"./admin/elements/table/da.yml": 679,
	"./admin/elements/table/en.yml": 680,
	"./admin/emails/admin_confirm_button/da.yml": 681,
	"./admin/emails/admin_confirm_button/en.yml": 682,
	"./admin/employee_prices/create_card/da.yml": 683,
	"./admin/employee_prices/create_card/en.yml": 684,
	"./admin/employee_prices/table/da.yml": 685,
	"./admin/employee_prices/table/en.yml": 686,
	"./admin/finance_dimension_values/table/da.yml": 687,
	"./admin/finance_dimension_values/table/en.yml": 688,
	"./admin/highscore_class_steps/edit/da.yml": 689,
	"./admin/highscore_class_steps/edit/en.yml": 690,
	"./admin/highscore_class_steps/table/da.yml": 691,
	"./admin/highscore_class_steps/table/en.yml": 692,
	"./admin/highscore_communes/table/da.yml": 693,
	"./admin/highscore_communes/table/en.yml": 694,
	"./admin/highscore_competitions/table/da.yml": 695,
	"./admin/highscore_competitions/table/en.yml": 696,
	"./admin/highscore_generation_surveys/show/da.yml": 697,
	"./admin/highscore_generation_surveys/show/en.yml": 698,
	"./admin/highscore_generation_teams/table/da.yml": 699,
	"./admin/highscore_generation_teams/table/en.yml": 700,
	"./admin/highscore_generations/nav/da.yml": 701,
	"./admin/highscore_generations/nav/en.yml": 702,
	"./admin/highscore_generations/overall_highscore/da.yml": 703,
	"./admin/highscore_generations/overall_highscore/en.yml": 704,
	"./admin/highscore_generations/participants/da.yml": 705,
	"./admin/highscore_generations/participants/en.yml": 706,
	"./admin/highscore_generations/show/da.yml": 707,
	"./admin/highscore_generations/show/en.yml": 708,
	"./admin/highscore_regions/table/da.yml": 709,
	"./admin/highscore_regions/table/en.yml": 710,
	"./admin/highscores/communes/da.yml": 711,
	"./admin/highscores/communes/en.yml": 712,
	"./admin/highscores/competitions/da.yml": 713,
	"./admin/highscores/competitions/en.yml": 714,
	"./admin/highscores/edit/da.yml": 715,
	"./admin/highscores/edit/en.yml": 716,
	"./admin/highscores/excluded_users/da.yml": 717,
	"./admin/highscores/excluded_users/en.yml": 718,
	"./admin/highscores/index/da.yml": 719,
	"./admin/highscores/index/en.yml": 720,
	"./admin/highscores/nav/da.yml": 721,
	"./admin/highscores/nav/en.yml": 722,
	"./admin/highscores/organizations/da.yml": 723,
	"./admin/highscores/organizations/en.yml": 724,
	"./admin/highscores/regions/da.yml": 725,
	"./admin/highscores/regions/en.yml": 726,
	"./admin/highscores/show/da.yml": 727,
	"./admin/highscores/show/en.yml": 728,
	"./admin/invoice_lines/create_card/da.yml": 729,
	"./admin/invoice_lines/create_card/en.yml": 730,
	"./admin/invoice_lines/table/da.yml": 731,
	"./admin/invoice_lines/table/en.yml": 732,
	"./admin/invoices/bottom_bar/da.yml": 733,
	"./admin/invoices/bottom_bar/en.yml": 734,
	"./admin/invoices/create_card/da.yml": 735,
	"./admin/invoices/create_card/en.yml": 736,
	"./admin/invoices/edit/da.yml": 737,
	"./admin/invoices/edit/en.yml": 738,
	"./admin/invoices/expandable_content/da.yml": 739,
	"./admin/invoices/expandable_content/en.yml": 740,
	"./admin/invoices/link/da.yml": 741,
	"./admin/invoices/link/en.yml": 742,
	"./admin/invoices/show/da.yml": 743,
	"./admin/invoices/show/en.yml": 744,
	"./admin/invoices/table/da.yml": 745,
	"./admin/invoices/table/en.yml": 746,
	"./admin/layout/bottom_bar/pagination/da.yml": 747,
	"./admin/layout/bottom_bar/pagination/en.yml": 748,
	"./admin/layout/da.yml": 749,
	"./admin/layout/en.yml": 750,
	"./admin/layout/slide_menu/da.yml": 751,
	"./admin/layout/slide_menu/en.yml": 752,
	"./admin/layout/slide_menu/index/da.yml": 753,
	"./admin/layout/slide_menu/index/en.yml": 754,
	"./admin/layout/top_menu/extended_search/da.yml": 755,
	"./admin/layout/top_menu/extended_search/en.yml": 756,
	"./admin/layout/top_menu/extended_search/group/da.yml": 757,
	"./admin/layout/top_menu/extended_search/group/en.yml": 758,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/chooser/da.yml": 759,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/chooser/en.yml": 760,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/da.yml": 761,
	"./admin/layout/top_menu/extended_search/group/rule/attribute_select/en.yml": 762,
	"./admin/layout/top_menu/extended_search/group/rule/da.yml": 763,
	"./admin/layout/top_menu/extended_search/group/rule/en.yml": 764,
	"./admin/layout/top_menu/search_bar/da.yml": 765,
	"./admin/layout/top_menu/search_bar/deleted_at_filter/da.yml": 766,
	"./admin/layout/top_menu/search_bar/deleted_at_filter/en.yml": 767,
	"./admin/layout/top_menu/search_bar/en.yml": 768,
	"./admin/layout/top_menu/user_menu_item/menu/da.yml": 769,
	"./admin/layout/top_menu/user_menu_item/menu/en.yml": 770,
	"./admin/layout_bottom_bar/pagination/da.yml": 771,
	"./admin/layout_bottom_bar/pagination/en.yml": 772,
	"./admin/logs/card/da.yml": 773,
	"./admin/logs/card/en.yml": 774,
	"./admin/logs/details/reimbursement/update/da.yml": 775,
	"./admin/logs/details/reimbursement/update/en.yml": 776,
	"./admin/logs/details/update/da.yml": 777,
	"./admin/logs/details/update/en.yml": 778,
	"./admin/logs/headers/create/da.yml": 779,
	"./admin/logs/headers/create/en.yml": 780,
	"./admin/logs/headers/update/da.yml": 781,
	"./admin/logs/headers/update/en.yml": 782,
	"./admin/logs/index/da.yml": 783,
	"./admin/logs/index/en.yml": 784,
	"./admin/logs/names/activity_participant/da.yml": 785,
	"./admin/logs/names/activity_participant/en.yml": 786,
	"./admin/logs/table/da.yml": 787,
	"./admin/logs/table/en.yml": 788,
	"./admin/messages/create_message_modal/da.yml": 789,
	"./admin/messages/create_message_modal/en.yml": 790,
	"./admin/messages/create_modal/da.yml": 791,
	"./admin/messages/create_modal/en.yml": 792,
	"./admin/messages/table/da.yml": 793,
	"./admin/messages/table/en.yml": 794,
	"./admin/navigations/index/da.yml": 795,
	"./admin/navigations/index/en.yml": 796,
	"./admin/navigations/my_location/da.yml": 797,
	"./admin/navigations/my_location/en.yml": 798,
	"./admin/navigations/show/da.yml": 799,
	"./admin/navigations/show/en.yml": 800,
	"./admin/order_lines/expandable_content/orderables/photo_sheet_product_order_line/da.yml": 801,
	"./admin/order_lines/expandable_content/orderables/photo_sheet_product_order_line/en.yml": 802,
	"./admin/order_lines/table/da.yml": 803,
	"./admin/order_lines/table/en.yml": 804,
	"./admin/orders/bottom_bar/da.yml": 805,
	"./admin/orders/bottom_bar/en.yml": 806,
	"./admin/orders/cancel_button/da.yml": 807,
	"./admin/orders/cancel_button/en.yml": 808,
	"./admin/orders/create_shipments_in_workplace_button/da.yml": 809,
	"./admin/orders/create_shipments_in_workplace_button/en.yml": 810,
	"./admin/orders/finish_process_button/da.yml": 811,
	"./admin/orders/finish_process_button/en.yml": 812,
	"./admin/orders/generate_file_button/da.yml": 813,
	"./admin/orders/generate_file_button/en.yml": 814,
	"./admin/orders/generate_file_for_orders_in_workplace_button/da.yml": 815,
	"./admin/orders/generate_file_for_orders_in_workplace_button/en.yml": 816,
	"./admin/orders/generate_packing_slips_for_orders_in_workplace_button/da.yml": 817,
	"./admin/orders/generate_packing_slips_for_orders_in_workplace_button/en.yml": 818,
	"./admin/orders/index/da.yml": 819,
	"./admin/orders/index/en.yml": 820,
	"./admin/orders/order_lines/da.yml": 821,
	"./admin/orders/order_lines/en.yml": 822,
	"./admin/orders/process_button/da.yml": 823,
	"./admin/orders/process_button/en.yml": 824,
	"./admin/orders/show/da.yml": 825,
	"./admin/orders/show/en.yml": 826,
	"./admin/orders/statistics_modal/da.yml": 827,
	"./admin/orders/statistics_modal/en.yml": 828,
	"./admin/orders/table/da.yml": 829,
	"./admin/orders/table/en.yml": 830,
	"./admin/organizations/edit/da.yml": 831,
	"./admin/organizations/edit/en.yml": 832,
	"./admin/organizations/index/da.yml": 833,
	"./admin/organizations/index/en.yml": 834,
	"./admin/organizations/show/da.yml": 835,
	"./admin/organizations/show/en.yml": 836,
	"./admin/people/table/da.yml": 837,
	"./admin/people/table/en.yml": 838,
	"./admin/person_roles/create_for_contacts_modal/da.yml": 839,
	"./admin/person_roles/create_for_contacts_modal/en.yml": 840,
	"./admin/photo_colors/create_card/da.yml": 841,
	"./admin/photo_colors/create_card/en.yml": 842,
	"./admin/photo_colors/select/da.yml": 843,
	"./admin/photo_colors/select/en.yml": 844,
	"./admin/photo_products/resource_select/da.yml": 845,
	"./admin/photo_products/resource_select/en.yml": 846,
	"./admin/photo_products/table/da.yml": 847,
	"./admin/photo_products/table/en.yml": 848,
	"./admin/photo_qualities/create_card/da.yml": 849,
	"./admin/photo_qualities/create_card/en.yml": 850,
	"./admin/photo_qualities/select/da.yml": 851,
	"./admin/photo_qualities/select/en.yml": 852,
	"./admin/photo_session_group_contacts/table/da.yml": 853,
	"./admin/photo_session_group_contacts/table/en.yml": 854,
	"./admin/photo_sessions/actions_bar/da.yml": 855,
	"./admin/photo_sessions/actions_bar/en.yml": 856,
	"./admin/photo_sessions/bottom_bar/da.yml": 857,
	"./admin/photo_sessions/bottom_bar/en.yml": 858,
	"./admin/photo_sessions/nav/da.yml": 859,
	"./admin/photo_sessions/nav/en.yml": 860,
	"./admin/photo_sessions/row/da.yml": 861,
	"./admin/photo_sessions/row/en.yml": 862,
	"./admin/photo_sessions/show/index/da.yml": 863,
	"./admin/photo_sessions/show/index/en.yml": 864,
	"./admin/photo_sessions/split_view/da.yml": 865,
	"./admin/photo_sessions/split_view/en.yml": 866,
	"./admin/photo_sessions/table/da.yml": 867,
	"./admin/photo_sessions/table/en.yml": 868,
	"./admin/photo_sessions/tree/da.yml": 869,
	"./admin/photo_sessions/tree/en.yml": 870,
	"./admin/photo_sessions/upload_csv_modal/index/da.yml": 871,
	"./admin/photo_sessions/upload_csv_modal/index/en.yml": 872,
	"./admin/photo_sheet_product_sheet_layouts/create_card/da.yml": 873,
	"./admin/photo_sheet_product_sheet_layouts/create_card/en.yml": 874,
	"./admin/photo_sheet_products/edit/da.yml": 875,
	"./admin/photo_sheet_products/edit/en.yml": 876,
	"./admin/photo_sheet_products/select/da.yml": 877,
	"./admin/photo_sheet_products/select/en.yml": 878,
	"./admin/photo_types/create_card/da.yml": 879,
	"./admin/photo_types/create_card/en.yml": 880,
	"./admin/photo_types/select/da.yml": 881,
	"./admin/photo_types/select/en.yml": 882,
	"./admin/photos/add_photo_type_to_photos_in_workplace_modal/da.yml": 883,
	"./admin/photos/add_photo_type_to_photos_in_workplace_modal/en.yml": 884,
	"./admin/photos/canvas/da.yml": 885,
	"./admin/photos/canvas/en.yml": 886,
	"./admin/photos/create_card/da.yml": 887,
	"./admin/photos/create_card/en.yml": 888,
	"./admin/photos/table/da.yml": 889,
	"./admin/photos/table/en.yml": 890,
	"./admin/photos/upload_card/da.yml": 891,
	"./admin/photos/upload_card/en.yml": 892,
	"./admin/plans/edit/da.yml": 893,
	"./admin/plans/edit/en.yml": 894,
	"./admin/plans/show/da.yml": 895,
	"./admin/plans/show/en.yml": 896,
	"./admin/plans/subscriptions/da.yml": 897,
	"./admin/plans/subscriptions/en.yml": 898,
	"./admin/plans/table/da.yml": 899,
	"./admin/plans/table/en.yml": 900,
	"./admin/products/select/da.yml": 901,
	"./admin/products/select/en.yml": 902,
	"./admin/products/show/da.yml": 903,
	"./admin/products/show/en.yml": 904,
	"./admin/reimbursement/table/da.yml": 905,
	"./admin/reimbursement/table/en.yml": 906,
	"./admin/reimbursement_attachments/expandable_content/da.yml": 907,
	"./admin/reimbursement_attachments/expandable_content/description/da.yml": 908,
	"./admin/reimbursement_attachments/expandable_content/description/en.yml": 909,
	"./admin/reimbursement_attachments/expandable_content/en.yml": 910,
	"./admin/reimbursement_attachments/table/da.yml": 911,
	"./admin/reimbursement_attachments/table/en.yml": 912,
	"./admin/reimbursements/attachments/da.yml": 913,
	"./admin/reimbursements/attachments/en.yml": 914,
	"./admin/reimbursements/bottom_bar/da.yml": 915,
	"./admin/reimbursements/bottom_bar/en.yml": 916,
	"./admin/reimbursements/expense/da.yml": 917,
	"./admin/reimbursements/expense/en.yml": 918,
	"./admin/reimbursements/expense_sum/index/da.yml": 919,
	"./admin/reimbursements/expense_sum/index/en.yml": 920,
	"./admin/reimbursements/index/da.yml": 921,
	"./admin/reimbursements/index/en.yml": 922,
	"./admin/reimbursements/nav/da.yml": 923,
	"./admin/reimbursements/nav/en.yml": 924,
	"./admin/reimbursements/process/da.yml": 925,
	"./admin/reimbursements/process/en.yml": 926,
	"./admin/reimbursements/time/da.yml": 927,
	"./admin/reimbursements/time/en.yml": 928,
	"./admin/reimbursements/travel/da.yml": 929,
	"./admin/reimbursements/travel/en.yml": 930,
	"./admin/reimbursements/travel_sum/index/da.yml": 931,
	"./admin/reimbursements/travel_sum/index/en.yml": 932,
	"./admin/required_metadata/card/da.yml": 933,
	"./admin/required_metadata/card/en.yml": 934,
	"./admin/role_abilities/edit/da.yml": 935,
	"./admin/role_abilities/edit/en.yml": 936,
	"./admin/role_abilities/lock_icon/da.yml": 937,
	"./admin/role_abilities/lock_icon/en.yml": 938,
	"./admin/role_ability_groups/lock_icon/da.yml": 939,
	"./admin/role_ability_groups/lock_icon/en.yml": 940,
	"./admin/roles/abilities/da.yml": 941,
	"./admin/roles/abilities/en.yml": 942,
	"./admin/roles/ability_groups/da.yml": 943,
	"./admin/roles/ability_groups/en.yml": 944,
	"./admin/roles/edit/da.yml": 945,
	"./admin/roles/edit/en.yml": 946,
	"./admin/roles/show/da.yml": 947,
	"./admin/roles/show/en.yml": 948,
	"./admin/routes/contact_relationships/edit/da.yml": 949,
	"./admin/routes/contact_relationships/edit/en.yml": 950,
	"./admin/routes/webshop/photo_products/da.yml": 951,
	"./admin/routes/webshop/photo_products/en.yml": 952,
	"./admin/routes/webshop/tenant_photo_products/da.yml": 953,
	"./admin/routes/webshop/tenant_photo_products/en.yml": 954,
	"./admin/school_classes/index/da.yml": 955,
	"./admin/school_classes/index/en.yml": 956,
	"./admin/school_classes/table/da.yml": 957,
	"./admin/school_classes/table/en.yml": 958,
	"./admin/school_years/index/da.yml": 959,
	"./admin/school_years/index/en.yml": 960,
	"./admin/sending_rules/create_card/da.yml": 961,
	"./admin/sending_rules/create_card/en.yml": 962,
	"./admin/sending_rules/table/da.yml": 963,
	"./admin/sending_rules/table/en.yml": 964,
	"./admin/sheet_layout_boxes/edit_modal/edit_box_icon/da.yml": 965,
	"./admin/sheet_layout_boxes/edit_modal/edit_box_icon/en.yml": 966,
	"./admin/sheet_layouts/create_card/da.yml": 967,
	"./admin/sheet_layouts/create_card/en.yml": 968,
	"./admin/sheet_layouts/select/da.yml": 969,
	"./admin/sheet_layouts/select/en.yml": 970,
	"./admin/sheet_layouts/show/da.yml": 971,
	"./admin/sheet_layouts/show/duplicate_box_icon/da.yml": 972,
	"./admin/sheet_layouts/show/duplicate_box_icon/en.yml": 973,
	"./admin/sheet_layouts/show/en.yml": 974,
	"./admin/sheet_layouts/show/remove_box_icon/da.yml": 975,
	"./admin/sheet_layouts/show/remove_box_icon/en.yml": 976,
	"./admin/sheet_layouts_boxes/form/edit_box_icon/da.yml": 977,
	"./admin/sheet_layouts_boxes/form/edit_box_icon/en.yml": 978,
	"./admin/sheet_sizes/create_card/da.yml": 979,
	"./admin/sheet_sizes/create_card/en.yml": 980,
	"./admin/sheet_sizes/select/da.yml": 981,
	"./admin/sheet_sizes/select/en.yml": 982,
	"./admin/show_box_attributes/form/da.yml": 983,
	"./admin/show_box_attributes/form/en.yml": 984,
	"./admin/show_boxes/form/da.yml": 985,
	"./admin/show_boxes/form/en.yml": 986,
	"./admin/show_boxes/partial/attribute/da.yml": 987,
	"./admin/show_boxes/partial/attribute/en.yml": 988,
	"./admin/show_boxes/partial/box/da.yml": 989,
	"./admin/show_boxes/partial/box/en.yml": 990,
	"./admin/show_boxes/partial/da.yml": 991,
	"./admin/show_boxes/partial/en.yml": 992,
	"./admin/steps/da.yml": 993,
	"./admin/steps/edit/da.yml": 994,
	"./admin/steps/edit/en.yml": 995,
	"./admin/steps/element/da.yml": 996,
	"./admin/steps/element/en.yml": 997,
	"./admin/steps/element_feedback/da.yml": 998,
	"./admin/steps/element_feedback/en.yml": 999,
	"./admin/steps/element_feedback_option/da.yml": 1000,
	"./admin/steps/element_feedback_option/en.yml": 1001,
	"./admin/steps/elements/da.yml": 1002,
	"./admin/steps/elements/en.yml": 1003,
	"./admin/steps/en.yml": 1004,
	"./admin/steps/show/da.yml": 1005,
	"./admin/steps/show/en.yml": 1006,
	"./admin/steps/table/da.yml": 1007,
	"./admin/steps/table/en.yml": 1008,
	"./admin/student_council_memberships/edit/da.yml": 1009,
	"./admin/student_council_memberships/edit/en.yml": 1010,
	"./admin/subjects/select/da.yml": 1011,
	"./admin/subjects/select/en.yml": 1012,
	"./admin/subscription_periods/table/da.yml": 1013,
	"./admin/subscription_periods/table/en.yml": 1014,
	"./admin/subscription_renewal_generations/show/da.yml": 1015,
	"./admin/subscription_renewal_generations/show/en.yml": 1016,
	"./admin/subscription_renewal_generations/table/da.yml": 1017,
	"./admin/subscription_renewal_generations/table/en.yml": 1018,
	"./admin/subscriptions/show/da.yml": 1019,
	"./admin/subscriptions/show/en.yml": 1020,
	"./admin/subscriptions/table/da.yml": 1021,
	"./admin/subscriptions/table/en.yml": 1022,
	"./admin/supplier_supported_photo_qualities/create_card/da.yml": 1023,
	"./admin/supplier_supported_photo_qualities/create_card/en.yml": 1024,
	"./admin/supplier_supported_sheets/create_card/da.yml": 1025,
	"./admin/supplier_supported_sheets/create_card/en.yml": 1026,
	"./admin/suppliers/select/da.yml": 1027,
	"./admin/suppliers/select/en.yml": 1028,
	"./admin/survey_judges/row/da.yml": 1029,
	"./admin/survey_judges/row/en.yml": 1030,
	"./admin/surveys/activation_button/da.yml": 1031,
	"./admin/surveys/activation_button/en.yml": 1032,
	"./admin/surveys/edit/da.yml": 1033,
	"./admin/surveys/edit/en.yml": 1034,
	"./admin/surveys/index/da.yml": 1035,
	"./admin/surveys/index/en.yml": 1036,
	"./admin/surveys/nav/da.yml": 1037,
	"./admin/surveys/nav/en.yml": 1038,
	"./admin/surveys/show/da.yml": 1039,
	"./admin/surveys/show/en.yml": 1040,
	"./admin/surveys/survey_details/da.yml": 1041,
	"./admin/surveys/survey_details/en.yml": 1042,
	"./admin/surveys/survey_steps/da.yml": 1043,
	"./admin/surveys/survey_steps/en.yml": 1044,
	"./admin/surveys/table/da.yml": 1045,
	"./admin/surveys/table/en.yml": 1046,
	"./admin/taggings/taggable/da.yml": 1047,
	"./admin/taggings/taggable/en.yml": 1048,
	"./admin/taggings/taggable/form/da.yml": 1049,
	"./admin/taggings/taggable/form/en.yml": 1050,
	"./admin/tags/workplace_merge_button/da.yml": 1051,
	"./admin/tags/workplace_merge_button/en.yml": 1052,
	"./admin/team_surveys/bottom_bar/da.yml": 1053,
	"./admin/team_surveys/bottom_bar/en.yml": 1054,
	"./admin/team_surveys/index/da.yml": 1055,
	"./admin/team_surveys/index/en.yml": 1056,
	"./admin/team_surveys/show/da.yml": 1057,
	"./admin/team_surveys/show/en.yml": 1058,
	"./admin/team_surveys/show/user_step/da.yml": 1059,
	"./admin/team_surveys/show/user_step/en.yml": 1060,
	"./admin/team_surveys/table/da.yml": 1061,
	"./admin/team_surveys/table/en.yml": 1062,
	"./admin/team_users/edit/da.yml": 1063,
	"./admin/team_users/edit/en.yml": 1064,
	"./admin/team_users/show/da.yml": 1065,
	"./admin/team_users/show/en.yml": 1066,
	"./admin/teams/edit/da.yml": 1067,
	"./admin/teams/edit/en.yml": 1068,
	"./admin/teams/index/da.yml": 1069,
	"./admin/teams/index/en.yml": 1070,
	"./admin/teams/show/da.yml": 1071,
	"./admin/teams/show/en.yml": 1072,
	"./admin/templates/create_card/da.yml": 1073,
	"./admin/templates/create_card/en.yml": 1074,
	"./admin/tenant_domains/row/da.yml": 1075,
	"./admin/tenant_domains/row/en.yml": 1076,
	"./admin/tenant_domains/select/da.yml": 1077,
	"./admin/tenant_domains/select/en.yml": 1078,
	"./admin/tenant_photo_products/create_card/da.yml": 1079,
	"./admin/tenant_photo_products/create_card/en.yml": 1080,
	"./admin/tenant_photo_products/visible_in_shop/da.yml": 1081,
	"./admin/tenant_photo_products/visible_in_shop/en.yml": 1082,
	"./admin/tenants/create_card/da.yml": 1083,
	"./admin/tenants/create_card/en.yml": 1084,
	"./admin/tenants/integrations/bambora/da.yml": 1085,
	"./admin/tenants/integrations/bambora/en.yml": 1086,
	"./admin/tenants/integrations/inventio/da.yml": 1087,
	"./admin/tenants/integrations/inventio/en.yml": 1088,
	"./admin/tenants/integrations/nav/da.yml": 1089,
	"./admin/tenants/integrations/nav/en.yml": 1090,
	"./admin/tenants/integrations/shipmondo/da.yml": 1091,
	"./admin/tenants/integrations/shipmondo/en.yml": 1092,
	"./admin/tenants/nav/da.yml": 1093,
	"./admin/tenants/nav/en.yml": 1094,
	"./admin/tenants/setup/da.yml": 1095,
	"./admin/tenants/setup/en.yml": 1096,
	"./admin/toggle_eye_button/da.yml": 1097,
	"./admin/toggle_eye_button/en.yml": 1098,
	"./admin/user_elements/answer/da.yml": 1099,
	"./admin/user_elements/answer/en.yml": 1100,
	"./admin/user_elements/edit/da.yml": 1101,
	"./admin/user_elements/edit/en.yml": 1102,
	"./admin/users/edit/da.yml": 1103,
	"./admin/users/edit/en.yml": 1104,
	"./admin/users/index/da.yml": 1105,
	"./admin/users/index/en.yml": 1106,
	"./admin/users/passwords/edit/da.yml": 1107,
	"./admin/users/passwords/edit/en.yml": 1108,
	"./admin/users/passwords/new/da.yml": 1109,
	"./admin/users/passwords/new/en.yml": 1110,
	"./admin/users/show/da.yml": 1111,
	"./admin/users/show/en.yml": 1112,
	"./admin/workplaces/bottom_bar/add_relationship_to_workplace_modal/da.yml": 1113,
	"./admin/workplaces/bottom_bar/add_relationship_to_workplace_modal/en.yml": 1114,
	"./admin/workplaces/bottom_bar/da.yml": 1115,
	"./admin/workplaces/bottom_bar/en.yml": 1116,
	"./admin/workplaces/bottom_bar/index/da.yml": 1117,
	"./admin/workplaces/bottom_bar/index/en.yml": 1118,
	"./agenda_item_elements/edit/audio/da.yml": 1119,
	"./agenda_item_elements/edit/audio/en.yml": 1120,
	"./agenda_item_elements/edit/document/da.yml": 1121,
	"./agenda_item_elements/edit/document/en.yml": 1122,
	"./agenda_item_elements/edit/image/da.yml": 1123,
	"./agenda_item_elements/edit/image/en.yml": 1124,
	"./agendas/actions_bar/da.yml": 1125,
	"./agendas/actions_bar/en.yml": 1126,
	"./agendas/live/da.yml": 1127,
	"./agendas/live/en.yml": 1128,
	"./bank_accounts/account_type_select/da.yml": 1129,
	"./bank_accounts/account_type_select/en.yml": 1130,
	"./block_ui/da.yml": 1131,
	"./block_ui/en.yml": 1132,
	"./buttons/table_expand/da.yml": 1133,
	"./buttons/table_expand/en.yml": 1134,
	"./classSteps/select/da.yml": 1135,
	"./classSteps/select/en.yml": 1136,
	"./competitions/choose_survey/da.yml": 1137,
	"./competitions/choose_survey/en.yml": 1138,
	"./competitions/choose_team/da.yml": 1139,
	"./competitions/choose_team/en.yml": 1140,
	"./competitions/choose_team_type/da.yml": 1141,
	"./competitions/choose_team_type/en.yml": 1142,
	"./competitions/index/da.yml": 1143,
	"./competitions/index/en.yml": 1144,
	"./competitions/show/da.yml": 1145,
	"./competitions/show/en.yml": 1146,
	"./competitions_choose_team/da.yml": 1147,
	"./competitions_choose_team/en.yml": 1148,
	"./components/responsive_nav/da.yml": 1149,
	"./components/responsive_nav/en.yml": 1150,
	"./confirm_dialog/da.yml": 1151,
	"./confirm_dialog/en.yml": 1152,
	"./contact_merge_requests/confirm_merge_request/da.yml": 1153,
	"./contact_merge_requests/confirm_merge_request/en.yml": 1154,
	"./contact_merge_requests/merge_request/da.yml": 1155,
	"./contact_merge_requests/merge_request/en.yml": 1156,
	"./contacts/select/da.yml": 1157,
	"./contacts/select/en.yml": 1158,
	"./election/school_elections/new/da.yml": 1159,
	"./election/school_elections/new/en.yml": 1160,
	"./element_types/da.yml": 1161,
	"./element_types/en.yml": 1162,
	"./feedback_assignments/show/da.yml": 1163,
	"./feedback_assignments/show/en.yml": 1164,
	"./feedback_steps/da.yml": 1165,
	"./feedback_steps/dropdown/da.yml": 1166,
	"./feedback_steps/dropdown/en.yml": 1167,
	"./feedback_steps/edit/da.yml": 1168,
	"./feedback_steps/edit/en.yml": 1169,
	"./feedback_steps/en.yml": 1170,
	"./flash_message/da.yml": 1171,
	"./flash_message/en.yml": 1172,
	"./forms/attachment_input/da.yml": 1173,
	"./forms/attachment_input/en.yml": 1174,
	"./forms/image_input/da.yml": 1175,
	"./forms/image_input/en.yml": 1176,
	"./global/da.yml": 1177,
	"./global/en.yml": 1178,
	"./jobler/job_status/da.yml": 1179,
	"./jobler/job_status/en.yml": 1180,
	"./layout/da.yml": 1181,
	"./layout/en.yml": 1182,
	"./layout/no_access/da.yml": 1183,
	"./layout/no_access/en.yml": 1184,
	"./layout/not_found/da.yml": 1185,
	"./layout/not_found/en.yml": 1186,
	"./layout/require_two_factor_authentication_proxy/da.yml": 1187,
	"./layout/require_two_factor_authentication_proxy/en.yml": 1188,
	"./layout/top_menu/user_meun_item/menu/da.yml": 1189,
	"./layout/top_menu/user_meun_item/menu/en.yml": 1190,
	"./layout/top_nav/da.yml": 1191,
	"./layout/top_nav/en.yml": 1192,
	"./layout/top_nav/notifications_modal/da.yml": 1193,
	"./layout/top_nav/notifications_modal/en.yml": 1194,
	"./live_streaming_feeds/broadcaster/index/da.yml": 1195,
	"./live_streaming_feeds/broadcaster/index/en.yml": 1196,
	"./live_streaming_feeds/broadcaster/settings/da.yml": 1197,
	"./live_streaming_feeds/broadcaster/settings/en.yml": 1198,
	"./live_streaming_feeds/viewer/da.yml": 1199,
	"./live_streaming_feeds/viewer/en.yml": 1200,
	"./merfoto/albums/index/da.yml": 1201,
	"./merfoto/albums/index/en.yml": 1202,
	"./merfoto/basket/basket_item_card/index/da.yml": 1203,
	"./merfoto/basket/basket_item_card/index/en.yml": 1204,
	"./merfoto/basket/da.yml": 1205,
	"./merfoto/basket/destroy_order_line_button/da.yml": 1206,
	"./merfoto/basket/destroy_order_line_button/en.yml": 1207,
	"./merfoto/basket/en.yml": 1208,
	"./merfoto/basket/quantity/da.yml": 1209,
	"./merfoto/basket/quantity/en.yml": 1210,
	"./merfoto/basket/unique_photos_label/da.yml": 1211,
	"./merfoto/basket/unique_photos_label/en.yml": 1212,
	"./merfoto/checkout/completed/da.yml": 1213,
	"./merfoto/checkout/completed/en.yml": 1214,
	"./merfoto/checkout/confirm/da.yml": 1215,
	"./merfoto/checkout/confirm/en.yml": 1216,
	"./merfoto/checkout/customer_information/da.yml": 1217,
	"./merfoto/checkout/customer_information/en.yml": 1218,
	"./merfoto/checkout/delivery/da.yml": 1219,
	"./merfoto/checkout/delivery/en.yml": 1220,
	"./merfoto/checkout/navbar/da.yml": 1221,
	"./merfoto/checkout/navbar/en.yml": 1222,
	"./merfoto/checkout/payment/da.yml": 1223,
	"./merfoto/checkout/payment/en.yml": 1224,
	"./merfoto/components/order_lines/edit/resources/bundle/da.yml": 1225,
	"./merfoto/components/order_lines/edit/resources/bundle/en.yml": 1226,
	"./merfoto/components/sheet-layouts/presentation/da.yml": 1227,
	"./merfoto/components/sheet-layouts/presentation/en.yml": 1228,
	"./merfoto/downloads/da.yml": 1229,
	"./merfoto/downloads/en.yml": 1230,
	"./merfoto/layout/footer/da.yml": 1231,
	"./merfoto/layout/footer/en.yml": 1232,
	"./merfoto/layout/footer/index/da.yml": 1233,
	"./merfoto/layout/footer/index/en.yml": 1234,
	"./merfoto/layout/index/da.yml": 1235,
	"./merfoto/layout/index/en.yml": 1236,
	"./merfoto/layout/top_bar/index/da.yml": 1237,
	"./merfoto/layout/top_bar/index/en.yml": 1238,
	"./merfoto/layout/top_bar/signed_in_user_button/menu_modal/da.yml": 1239,
	"./merfoto/layout/top_bar/signed_in_user_button/menu_modal/en.yml": 1240,
	"./merfoto/layout/topbar/index/da.yml": 1241,
	"./merfoto/layout/topbar/index/en.yml": 1242,
	"./merfoto/order_deliveries/delivery_methods/digital_download/options/da.yml": 1243,
	"./merfoto/order_deliveries/delivery_methods/digital_download/options/en.yml": 1244,
	"./merfoto/order_deliveries/delivery_methods/pick_up/index/da.yml": 1245,
	"./merfoto/order_deliveries/delivery_methods/pick_up/index/en.yml": 1246,
	"./merfoto/order_deliveries/delivery_methods/shipmondo/index/da.yml": 1247,
	"./merfoto/order_deliveries/delivery_methods/shipmondo/index/en.yml": 1248,
	"./merfoto/order_lines/edit/submit_image_button/da.yml": 1249,
	"./merfoto/order_lines/edit/submit_image_button/en.yml": 1250,
	"./merfoto/orders/da.yml": 1251,
	"./merfoto/orders/en.yml": 1252,
	"./merfoto/orders/table/da.yml": 1253,
	"./merfoto/orders/table/en.yml": 1254,
	"./merfoto/orders/total_with_delivery/da.yml": 1255,
	"./merfoto/orders/total_with_delivery/en.yml": 1256,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_card/da.yml": 1257,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_card/en.yml": 1258,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_form/da.yml": 1259,
	"./merfoto/photo_session_group_contact_tokens/create_from_token_form/en.yml": 1260,
	"./merfoto/photo_session_group_contacts/select_album/da.yml": 1261,
	"./merfoto/photo_session_group_contacts/select_album/en.yml": 1262,
	"./merfoto/photo_session_groups/card/index/da.yml": 1263,
	"./merfoto/photo_session_groups/card/index/en.yml": 1264,
	"./merfoto/photo_session_groups/card/photo_card/da.yml": 1265,
	"./merfoto/photo_session_groups/card/photo_card/en.yml": 1266,
	"./merfoto/photo_sheet_product_order_lines/edit/da.yml": 1267,
	"./merfoto/photo_sheet_product_order_lines/edit/en.yml": 1268,
	"./merfoto/routes/albums/da.yml": 1269,
	"./merfoto/routes/albums/en.yml": 1270,
	"./merfoto/routes/welcome/da.yml": 1271,
	"./merfoto/routes/welcome/en.yml": 1272,
	"./merfoto/tenant_photo_products/add_to_basket_button/da.yml": 1273,
	"./merfoto/tenant_photo_products/add_to_basket_button/en.yml": 1274,
	"./merfoto/tenant_photo_products_with_photos/card/index/da.yml": 1275,
	"./merfoto/tenant_photo_products_with_photos/card/index/en.yml": 1276,
	"./merfoto/tenant_photo_products_with_photos/index/da.yml": 1277,
	"./merfoto/tenant_photo_products_with_photos/index/en.yml": 1278,
	"./merfoto/token/da.yml": 1279,
	"./merfoto/token/en.yml": 1280,
	"./merfoto/users/passwords/new/da.yml": 1281,
	"./merfoto/users/passwords/new/en.yml": 1282,
	"./merfoto/welcome/da.yml": 1283,
	"./merfoto/welcome/en.yml": 1284,
	"./merfoto/welcome_top_container/index/da.yml": 1285,
	"./merfoto/welcome_top_container/index/en.yml": 1286,
	"./models_table/add_column_button/da.yml": 1287,
	"./models_table/add_column_button/en.yml": 1288,
	"./models_table/columns_drop_down/da.yml": 1289,
	"./models_table/columns_drop_down/en.yml": 1290,
	"./navigations/index/da.yml": 1291,
	"./navigations/index/en.yml": 1292,
	"./navigations/show/da.yml": 1293,
	"./navigations/show/en.yml": 1294,
	"./nemoa/activities/elections/election/da.yml": 1295,
	"./nemoa/activities/elections/election/en.yml": 1296,
	"./nemoa/activities/index/card/participant_state_overlay/index/da.yml": 1297,
	"./nemoa/activities/index/card/participant_state_overlay/index/en.yml": 1298,
	"./nemoa/activities/mine/index/da.yml": 1299,
	"./nemoa/activities/mine/index/en.yml": 1300,
	"./nemoa/activities/nav/index/da.yml": 1301,
	"./nemoa/activities/nav/index/en.yml": 1302,
	"./nemoa/activities/required_metadata_proxy_with_surveys/da.yml": 1303,
	"./nemoa/activities/required_metadata_proxy_with_surveys/en.yml": 1304,
	"./nemoa/activities/show/elections/da.yml": 1305,
	"./nemoa/activities/show/elections/en.yml": 1306,
	"./nemoa/activities/show/elections/index/da.yml": 1307,
	"./nemoa/activities/show/elections/index/en.yml": 1308,
	"./nemoa/activities/show/index/da.yml": 1309,
	"./nemoa/activities/show/index/en.yml": 1310,
	"./nemoa/activities/show/live/da.yml": 1311,
	"./nemoa/activities/show/live/en.yml": 1312,
	"./nemoa/activities/show/nav/da.yml": 1313,
	"./nemoa/activities/show/nav/en.yml": 1314,
	"./nemoa/activities/show/politics/da.yml": 1315,
	"./nemoa/activities/show/politics/en.yml": 1316,
	"./nemoa/components/user_steps/element_types/question_sentence/da.yml": 1317,
	"./nemoa/components/user_steps/element_types/question_sentence/en.yml": 1318,
	"./nemoa/layout/slide_menu/index/da.yml": 1319,
	"./nemoa/layout/slide_menu/index/en.yml": 1320,
	"./nemoa/layout/top_menu/index/da.yml": 1321,
	"./nemoa/layout/top_menu/index/en.yml": 1322,
	"./nemoa/layout/top_menu/user_menu_item/index/da.yml": 1323,
	"./nemoa/layout/top_menu/user_menu_item/index/en.yml": 1324,
	"./nemoa/required_metadata/required_metadata_proxy/da.yml": 1325,
	"./nemoa/required_metadata/required_metadata_proxy/en.yml": 1326,
	"./nemoa/user_steps/edit/da.yml": 1327,
	"./nemoa/user_steps/edit/en.yml": 1328,
	"./nemoa/users/edit/form/index/da.yml": 1329,
	"./nemoa/users/edit/form/index/en.yml": 1330,
	"./nemoa/users/passwords/new/da.yml": 1331,
	"./nemoa/users/passwords/new/en.yml": 1332,
	"./nemoa_select/da.yml": 1333,
	"./nemoa_select/en.yml": 1334,
	"./notifications/types/team_application_accepted/da.yml": 1335,
	"./notifications/types/team_application_accepted/en.yml": 1336,
	"./notifications/types/team_application_declined/da.yml": 1337,
	"./notifications/types/team_application_declined/en.yml": 1338,
	"./notifications/types/team_survey_started/da.yml": 1339,
	"./notifications/types/team_survey_started/en.yml": 1340,
	"./organizations/select/da.yml": 1341,
	"./organizations/select/en.yml": 1342,
	"./preview/da.yml": 1343,
	"./preview/en.yml": 1344,
	"./proposal_types/presenter_card/da.yml": 1345,
	"./proposal_types/presenter_card/en.yml": 1346,
	"./registrations/form/da.yml": 1347,
	"./registrations/form/en.yml": 1348,
	"./reimbursements/attachments/create_card/da.yml": 1349,
	"./reimbursements/attachments/create_card/en.yml": 1350,
	"./reimbursements/create_card/da.yml": 1351,
	"./reimbursements/create_card/en.yml": 1352,
	"./reimbursements/create_card/extended_form/save_and_request_approval_button/da.yml": 1353,
	"./reimbursements/create_card/extended_form/save_and_request_approval_button/en.yml": 1354,
	"./reimbursements/create_card/extended_form/save_button/da.yml": 1355,
	"./reimbursements/create_card/extended_form/save_button/en.yml": 1356,
	"./reimbursements/create_card/index/da.yml": 1357,
	"./reimbursements/create_card/index/en.yml": 1358,
	"./reimbursements/documents/da.yml": 1359,
	"./reimbursements/documents/en.yml": 1360,
	"./reimbursements/documents_button/carousel/da.yml": 1361,
	"./reimbursements/documents_button/carousel/en.yml": 1362,
	"./reimbursements/expenses/index/da.yml": 1363,
	"./reimbursements/expenses/index/en.yml": 1364,
	"./reimbursements/index/da.yml": 1365,
	"./reimbursements/index/en.yml": 1366,
	"./reimbursements/index/time_sum/da.yml": 1367,
	"./reimbursements/index/time_sum/en.yml": 1368,
	"./reimbursements/table/da.yml": 1369,
	"./reimbursements/table/en.yml": 1370,
	"./reimbursements/time/da.yml": 1371,
	"./reimbursements/time/en.yml": 1372,
	"./reimbursements/travel/index/da.yml": 1373,
	"./reimbursements/travel/index/en.yml": 1374,
	"./roles/select/da.yml": 1375,
	"./roles/select/en.yml": 1376,
	"./save_modes/da.yml": 1377,
	"./save_modes/en.yml": 1378,
	"./school_classes/select/da.yml": 1379,
	"./school_classes/select/en.yml": 1380,
	"./sessions/new/da.yml": 1381,
	"./sessions/new/en.yml": 1382,
	"./sessions/new/index/da.yml": 1383,
	"./sessions/new/index/en.yml": 1384,
	"./sessions/new/one_time_password_prompt/da.yml": 1385,
	"./sessions/new/one_time_password_prompt/en.yml": 1386,
	"./sessions/new/uni_login_image_button/da.yml": 1387,
	"./sessions/new/uni_login_image_button/en.yml": 1388,
	"./shared/create_card/da.yml": 1389,
	"./shared/create_card/en.yml": 1390,
	"./shared/da.yml": 1391,
	"./shared/en.yml": 1392,
	"./shared/preview/da.yml": 1393,
	"./shared/preview/en.yml": 1394,
	"./shared/preview/index/da.yml": 1395,
	"./shared/preview/index/en.yml": 1396,
	"./shared/state_selector/da.yml": 1397,
	"./shared/state_selector/en.yml": 1398,
	"./shared/table/index/da.yml": 1399,
	"./shared/table/index/en.yml": 1400,
	"./shared/table/row/da.yml": 1401,
	"./shared/table/row/en.yml": 1402,
	"./shared/tree/index/da.yml": 1403,
	"./shared/tree/index/en.yml": 1404,
	"./shared/tree/node/da.yml": 1405,
	"./shared/tree/node/en.yml": 1406,
	"./sheet_layouts/presentation/index/da.yml": 1407,
	"./sheet_layouts/presentation/index/en.yml": 1408,
	"./steps/da.yml": 1409,
	"./steps/en.yml": 1410,
	"./surveys/list_partial/da.yml": 1411,
	"./surveys/list_partial/en.yml": 1412,
	"./surveys/show/da.yml": 1413,
	"./surveys/show/en.yml": 1414,
	"./team_surveys/complete/da.yml": 1415,
	"./team_surveys/complete/en.yml": 1416,
	"./team_surveys/edit/da.yml": 1417,
	"./team_surveys/edit/en.yml": 1418,
	"./team_surveys/feedback_states/da.yml": 1419,
	"./team_surveys/feedback_states/en.yml": 1420,
	"./team_surveys/time_used/da.yml": 1421,
	"./team_surveys/time_used/en.yml": 1422,
	"./teams/edit/da.yml": 1423,
	"./teams/edit/en.yml": 1424,
	"./teams/selector/choose_team/da.yml": 1425,
	"./teams/selector/choose_team/en.yml": 1426,
	"./teams/show/da.yml": 1427,
	"./teams/show/en.yml": 1428,
	"./tenants/select/da.yml": 1429,
	"./tenants/select/en.yml": 1430,
	"./tenants/setup/da.yml": 1431,
	"./tenants/setup/en.yml": 1432,
	"./uni_logins/new/da.yml": 1433,
	"./uni_logins/new/en.yml": 1434,
	"./uni_logins/successful/da.yml": 1435,
	"./uni_logins/successful/en.yml": 1436,
	"./upload_button/index/da.yml": 1437,
	"./upload_button/index/en.yml": 1438,
	"./upload_button_with_preview/index/da.yml": 1439,
	"./upload_button_with_preview/index/en.yml": 1440,
	"./user_steps/edit/da.yml": 1441,
	"./user_steps/edit/en.yml": 1442,
	"./user_steps/element_types/question_dropdown/da.yml": 1443,
	"./user_steps/element_types/question_dropdown/en.yml": 1444,
	"./user_steps/element_types/question_file/index/da.yml": 1445,
	"./user_steps/element_types/question_file/index/en.yml": 1446,
	"./users/confirmation/da.yml": 1447,
	"./users/confirmation/en.yml": 1448,
	"./users/confirmation/index/da.yml": 1449,
	"./users/confirmation/index/en.yml": 1450,
	"./users/confirmation/new/da.yml": 1451,
	"./users/confirmation/new/en.yml": 1452,
	"./users/confirmations/new/da.yml": 1453,
	"./users/confirmations/new/en.yml": 1454,
	"./users/consent/index/da.yml": 1455,
	"./users/consent/index/en.yml": 1456,
	"./users/edit/form/da.yml": 1457,
	"./users/edit/form/en.yml": 1458,
	"./users/edit/form/index/da.yml": 1459,
	"./users/edit/form/index/en.yml": 1460,
	"./users/edit/form/relatives/da.yml": 1461,
	"./users/edit/form/relatives/en.yml": 1462,
	"./users/edit/form/two_factor_authentication/da.yml": 1463,
	"./users/edit/form/two_factor_authentication/en.yml": 1464,
	"./users/edit/school/da.yml": 1465,
	"./users/edit/school/en.yml": 1466,
	"./users/notifications/partial/da.yml": 1467,
	"./users/notifications/partial/en.yml": 1468,
	"./users/passwords/edit/da.yml": 1469,
	"./users/passwords/edit/en.yml": 1470,
	"./users/passwords/edit/index/da.yml": 1471,
	"./users/passwords/edit/index/en.yml": 1472,
	"./users/passwords/new/da.yml": 1473,
	"./users/passwords/new/en.yml": 1474,
	"./users/settings/da.yml": 1475,
	"./users/settings/en.yml": 1476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 404;